module.exports = __webpack_public_path__ + "img/32.7868d5e4.jpg";